import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TEST_BID } from 'src/app/const';

@Component({
  selector: 'tr[appBidsGuideDemoRow]',
  templateUrl: './bids-guide-demo-row.component.html',
  styleUrls: ['./bids-guide-demo-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BidsGuideDemoRowComponent {
  readonly bid = TEST_BID;
}
